import {InlineNotification} from '@/components/ui/InlineNotification';
import AutoDeliveryStatusTitle from '@/views/AutoDelivery/AutoDeliveryStatusTitle';

const EditDeliveryPopupTopSection = ({header, title, subtitle, infoText, icon}) => {
    return (
        <div className='pb-8 md:pb-0'>
            <AutoDeliveryStatusTitle title={header} className='text-28 md:text-36' />
            <div className='mt-8 flex items-center gap-2'>
                <div className='shrink-0'>{icon}</div>
                <div>
                    <p className='text-primary-dark-65'>{subtitle}</p>
                    <p className='mb-0 text-20 font-bold leading-13 text-primary-dark'>{title}</p>
                </div>
            </div>
            <InlineNotification className='mt-4 ml:bg-romance' body={infoText} />
        </div>
    );
};

export default EditDeliveryPopupTopSection;
